<app-mobile-head [key]=key (onGoTo)="goTo($event)"></app-mobile-head>
<div class="main-container">
  <div class="container main-content">
    <app-main-content [key]=key (onGoTo)="goTo($event)"></app-main-content>
    <app-mobile-footer></app-mobile-footer>
  </div>
</div>
